import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { emeraldRequest } from 'src/common/api/emerald-request';
import {
  CartBalanceInstructions,
  CartResponse,
} from 'src/items-list/business-logic/service/interfaces/cart-response';
import { ITenderAdd } from 'src/common/interfaces/dtos/IPreTenderAdd';

export const performTenderBalance = async (
  cartId: string | undefined,
  data: CartBalanceInstructions[] | undefined,
  tender: ITenderAdd,
): Promise<CartResponse> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${cartId}/balance-cart-with-tenders`,
    method: 'POST',
    data: { balanceInstructions: data, tenderLineId: tender.lineId },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  const response = await emeraldRequest<CartResponse>(emeraldRequestParams);
  return response;
};
